<template>
    <div 
        class="o-t-map t-map"
        :style="styles"
    >
        <OTerminalMapController />
        <ASwitchCircle
            v-if="shouldShowContrastSwitch"
            v-model="contrast"
            :label="$t('ui.switch-contrast')"
        />
        <OCompass
            :value="compassDegree"
        />
        <MZoomControls />
        <OResetMapView
            v-if="isShowResetMapView && isResetMapViewActive"
            @closeResetMapView="isShowResetMapView = false"
        />
        <OGoogleMaps
            v-if="isGoogleMaps"
            :stroke-color="strokeColor"
            :origin="exitGmapsPosition"
            :destination="destinationGmapsPosition"
            @onBackIndoors="onBackIndoors"
        />
        <AAboutMapButton 
            v-if="isShowAboutButton"
        />
    </div>
</template>

<script>
import {
    mapState,
    mapGetters
} from 'vuex';

import OGoogleMaps from '../../organisms/o-google-maps';
import OCompass from '../../organisms/o-compass/o-compass';
import ASwitchCircle from '../../atoms/a-switch-circle/a-switch-circle';
import MZoomControls from '../../molecules/m-zoom-controls/m-zoom-controls';
import OResetMapView from "../../organisms/o-reset-map-view/o-reset-map-view";
import AAboutMapButton from '../../atoms/a-about-map-button/a-about-map-button';
import OTerminalMapController from "../../organisms/o-terminal-map-controller/o-terminal-map-controller";

import {
    UI_ON_CAMERA_UPDATE,
    UI_MAP_CLICKED, UI_MAP_READY
} from '../../../shared/components/map-viewer/constants/map-events';

export default {
    name: 'OTMap',
    components: {
        OCompass,
        OGoogleMaps,
        MZoomControls,
        ASwitchCircle,
        OResetMapView,
        AAboutMapButton,
        OTerminalMapController
    },
    data() {
        return {
            switcher: false,
            compassDegree: 0,
            contrast: false,
            isShowResetMapView: false
        }
    },
    computed: {
        ...mapGetters([
            't',
            'isAppLoaded',
            'getMapConfigProp',
            'getObjectsByUnitName',
            'getDenormalisedObjectById',
            'getActiveGuideDestinationUnit'
        ]),
        ...mapState({
            activeStepIndex: state => state.activeStepIndex,
            activePath: state => state.activePath
        }),
        compassCorrectionValue() {
            return this.getMapConfigProp('compass_correction', 0);
        },
        shouldShowContrastSwitch() {
            return this.getMapConfigProp('features.map_controls.switch', 0);
        },
        isLastStep() {
            return this.activePath.steps.length - 1 === this.activeStepIndex;
        },
        isGoogleMaps() {
            return this.isAppLoaded
                && this.destinationGmapsPosition
                && this.exitGmapsPosition
                && this.isLastStep;
        },
        item() {
            return this.getDenormalisedObjectById(Number(this.$route.params.itemId));
        },
        destinationGmapsPosition() {
            return this.t(this.item, 'gmaps_position');
        },
        exit() {
            if (this.t(this.item, 'is_google_maps') && this.getActiveGuideDestinationUnit) {
                const objects = this.getObjectsByUnitName(this.getActiveGuideDestinationUnit);

                return objects.find(o => this.t(o, 'portal_type') === 'Exit');
            }

            return {};
        },
        exitGmapsPosition() {
            return this.t(this.exit, 'gmaps_position');
        },
        strokeColor() {
            return this.getMapConfigProp('components.OGoogleMaps.strokeColor');
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.footer.OTMap.params`) || {};
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OTMap.params') || {};
        },
        params() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        isShowAboutButton() {
            return this.params.is_show_about_modal
        },
        styles() {
            return this.getMapConfigProp('components.OTMap.styles') || {};
        },
        isResetMapViewActive() {
            return this.commonConfigParams.is_reset_map_view_active
        }
    },
    watch: {
        '$route'() {
            this.isShowResetMapView = false;
        },
        activeStepIndex() {
            this.isShowResetMapView = false;
        }
    },
    mounted() {
        this.initEventListeners();
    },
    beforeDestroy() {
        this.deactivateEventsListeners();
    },
    methods: {
        initEventListeners() {
            this.$bus.$on(UI_MAP_READY, this.onMapReady)
            this.$bus.$on(UI_MAP_CLICKED, this.onMapClicked);
        },
        onMapReady(){
            if(document.viewApi){
                document.viewApi.register_event('on_camera_update', this.updateOrientation);
                //document.viewApi.register_event('floor_clicked', this.onMapClicked);
            }
        },
        deactivateEventsListeners() {
            this.$bus.$off(UI_MAP_READY, this.onMapReady);
            this.$bus.$off(UI_MAP_CLICKED, this.onMapClicked);
            document.viewApi.deregister_event('on_camera_update', this.updateOrientation);
            //document.viewApi.deregister_event('floor_clicked', this.onMapClicked);
        },
        updateOrientation() {
            if(document.viewApi?.camera_controller.current_orientation)
                this.compassDegree = this.compassCorrectionValue +  document.viewApi.camera_controller.current_orientation;
        },
        onMapClicked() {
            this.isShowResetMapView = true;
        },
        onBackIndoors() {
            this.$store.commit('setActiveStepIndex', this.activeStepIndex - 1);
        }
    }
}  
</script>

<style lang="scss" src="./o-t-map.scss" />